
export default {
    api: {
        //服务器地址
        domain:'https://eqapi.htaq.net',
        //api地址
        base_url:  'https://eqapi.htaq.net/admin/rpc',
        //请求超时时间（单位S）
        timeout: 1000,
    },

    login_websocket_url:  'https://eqapi.htaq.net:39898', 

    page: {
        //每页显示条数
        page_size: 50
    },

    //文件服务器地址
    upload_url: 'https://eqapi.htaq.net/admin/rpc',
    //文件服务器地址
    file_srv:'https://eqapi.htaq.net'
}

